<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size sm_size">
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <slot name="header">
                            {{ $t('TITLE.EUR.PASSWORD.POPUP') }}
                        </slot>
                    </dt>
                    <dd>
                        <dl class="dl_input password_req">
                            <dt>
                                {{ rulesOne() }} <br />
                                {{ rulesTwo() }}
                            </dt>
                            <dd data-input-type="input">
                                <span class="clearable">
                                    <input
                                        type="password"
                                        class="text_input w100p"
                                        :placeholder="rulesTwo()"
                                        v-clearable
                                        v-model="pass"
                                        @keyup.enter.stop="goListBack"
                                        maxlength="5"
                                    />
                                </span>
                            </dd>
                        </dl>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_block" @click="goListBack">
                                    {{ $t('BUTTON.GLOBAL.OK') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { SDLUtil } from '@/utils';

export default {
    name: 'RequestPassPopup',
    props: {
        keyWord: '',
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pass: '',
        };
    },
    methods: {
        rulesOne() {
            return this.stripHtml(SDLUtil.getMsgProp('MESSAGE.EUR.PASSWORD.RULES.ONE'));
        },
        rulesTwo() {
            return this.stripHtml(SDLUtil.getMsgProp('MESSAGE.EUR.PASSWORD.RULES.TWO'));
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        goListBack() {
            if (this.keyWord === this.pass) {
                this.$emit('close');
                this.rtnFunc(true);
            } else {
                SDLUtil.alert('MESSAGE.EUR.PASSWORD.DIFFERENT');
            }
        },
        goClose() {
            this.$emit('close');
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/RequestPassPopup.vue